import { useMemo } from 'react'

import { CheckIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Drawer, Select } from 'flowbite-react'
import { useNavigate } from 'react-router-dom'

import Loader from '../Loader'
import PaginationItem from '../Table/pagination-item'
import TableItemPedidos from '../Table/table-item-pedidos.component'
import { useRevisarPedidosContext } from '@/contexts/revisar-pedido.context'
import { TABLE_HEADERS_REVISAO_PEDIDOS_OPERADORA } from '@/pages/Pedidos/constants'

interface DrawerPedidoRevisaoProps {
  isOpen: boolean | false
  onClose: any
}

export default function DrawerPedidoRevisao({
  isOpen,
  onClose
}: DrawerPedidoRevisaoProps) {
  const {
    vendas,
    isLoadingVendas,
    setVendasPage,
    vendasTotalPages,
    vendasPageSize,
    setVendasPageSize,
    unidadeId,
    unidade,
    pedidoId
  } = useRevisarPedidosContext()

  const navigate = useNavigate()

  const mapedProperties = useMemo(() => {
    return vendas?.conteudo?.resultados?.map(item => {
      return {
        pedidoId: pedidoId,
        operadora: item.nomeDaOperadora,
        qtdColaboradores: item.quantidadeDeCpfs,
        itens: item.totalVenda.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        }),
        situacao: item.contemErro ? (
          <XMarkIcon className='h-5 w-5 text-white bg-red-400 rounded-full justify-center items-center' />
        ) : (
          <CheckIcon className='h-5 w-5 text-white bg-quintenary rounded-full justify-center items-center' />
        ),
        acoes: (
          <Button
            color='gray'
            className='flex gap-2 justify-center items-center'
            onClick={() =>
              navigate(
                `/pedidos/${pedidoId}/editar-pedidos/${
                  item.idOperadora ?? 'vr-credito'
                }/${unidadeId}`
              )
            }
            data-testid='btn-edit'
          >
            <PencilIcon className='h-5 w-5' />
          </Button>
        )
      }
    })
  }, [vendas])

  return (
    <div data-testid='drawer-pedidos'>
      <Drawer
        open={isOpen}
        onClose={onClose}
        position='bottom'
        className='max-h-[70%]'
      >
        <Drawer.Header title={unidade} titleIcon={() => <></>} />
        <Drawer.Items>
          {isLoadingVendas ? (
            <div
              className='h-96 w-full flex justify-center items-center'
              data-testid='loader-drawer-pedidos-revisao'
            >
              <Loader size={'xl'} />
            </div>
          ) : (
            <div>
              <TableItemPedidos
                isActions={false}
                isRowClicable={false}
                data={mapedProperties || []}
                headers={TABLE_HEADERS_REVISAO_PEDIDOS_OPERADORA}
                deleteAction={() => void 0}
                hasCustomActions={false}
                idKey='vendaId'
                isIdle={false}
                data-testid='table-pedidos-operadoras'
              />
              <PaginationItem
                totalItems={vendas?.conteudo?.quantidadeDeItems}
                totalPages={vendasTotalPages}
                pageSize={vendasPageSize}
                onPageChange={(pageParam: number) => setVendasPage(pageParam)}
                forceDisplay={true}
              >
                <Select
                  id='select-page-size'
                  data-testid='select-page-size'
                  defaultValue={vendasPageSize}
                  onChange={e => setVendasPageSize(Number(e.target.value))}
                >
                  <option value='10'>10</option>
                  <option value='25'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                </Select>
              </PaginationItem>
            </div>
          )}
        </Drawer.Items>
      </Drawer>
    </div>
  )
}
